function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { extend } from '../vue';
import { EVENT_NAME_INPUT } from '../constants/events';
import { PROP_TYPE_ANY } from '../constants/props';
import { makeProp } from './props';
export var makeModelMixin = function makeModelMixin(prop) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? PROP_TYPE_ANY : _ref$type,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? undefined : _ref$defaultValue,
      _ref$validator = _ref.validator,
      validator = _ref$validator === void 0 ? undefined : _ref$validator,
      _ref$event = _ref.event,
      event = _ref$event === void 0 ? EVENT_NAME_INPUT : _ref$event;

  var props = _defineProperty({}, prop, makeProp(type, defaultValue, validator)); // @vue/component


  var mixin = extend({
    model: {
      prop: prop,
      event: event
    },
    props: props
  });
  return {
    mixin: mixin,
    props: props,
    prop: prop,
    event: event
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/model.js
// module id = 20
// module chunks = 0